import React from 'react';
import { Layout } from '../../components/Layout';
import { Checklist } from '../../components/Checklist';
import { Button } from '../../components/ui/Button';
import { Card } from '../../components/ui/Card';
import { ANDROID_CHECKLIST } from '../../utils/constants';
import { Smartphone, ShieldCheck, Lock, ArrowRight, AlertTriangle } from 'lucide-react';
import { Link } from 'react-router-dom';
export function Android() {
  return <Layout data-id="element-1869">
      <div className="container mx-auto px-4 py-12" data-id="element-1870">
        <div className="mb-12" data-id="element-1871">
          <div className="inline-flex items-center px-3 py-1 rounded-full bg-cyan-500/10 text-cyan-400 text-xs font-medium mb-4 border border-cyan-500/20" data-id="element-1872">
            <Smartphone className="h-3 w-3 mr-2" data-id="element-1873" />
            Device Library
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-slate-100 mb-4" data-id="element-1874">
            Android Security Protocol
          </h1>
          <p className="text-xl text-slate-400 max-w-3xl" data-id="element-1875">
            Panduan pengamanan ekosistem Android yang beragam.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-1876">
          <div className="lg:col-span-2 space-y-12" data-id="element-1877">
            <section data-id="element-1878">
              <h2 className="text-2xl font-bold text-slate-100 mb-6 flex items-center" data-id="element-1879">
                <ShieldCheck className="h-6 w-6 text-cyan-500 mr-3" data-id="element-1880" />
                Baseline Security
              </h2>
              <div className="space-y-4" data-id="element-1881">
                <Card className="p-5 border-l-4 border-l-cyan-500" data-id="element-1882">
                  <h3 className="font-bold text-slate-100 mb-1" data-id="element-1883">
                    Security Patch Level
                  </h3>
                  <p className="text-slate-400 text-sm" data-id="element-1884">
                    Pastikan update keamanan bulanan terinstal. Settings {'>'}{' '}
                    Security {'>'} Security update.
                  </p>
                </Card>
                <Card className="p-5 border-l-4 border-l-cyan-500" data-id="element-1885">
                  <h3 className="font-bold text-slate-100 mb-1" data-id="element-1886">
                    Google Play Protect
                  </h3>
                  <p className="text-slate-400 text-sm" data-id="element-1887">
                    Scanner malware bawaan yang wajib aktif. Jangan pernah
                    matikan.
                  </p>
                </Card>
                <Card className="p-5 border-l-4 border-l-cyan-500" data-id="element-1888">
                  <h3 className="font-bold text-slate-100 mb-1" data-id="element-1889">
                    No Sideloading
                  </h3>
                  <p className="text-slate-400 text-sm" data-id="element-1890">
                    Matikan "Install unknown apps" untuk browser dan file
                    manager kecuali sangat diperlukan.
                  </p>
                </Card>
              </div>
            </section>

            <section data-id="element-1891">
              <h2 className="text-2xl font-bold text-slate-100 mb-6 flex items-center" data-id="element-1892">
                <Lock className="h-6 w-6 text-cyan-500 mr-3" data-id="element-1893" />
                Advanced Measures
              </h2>
              <ul className="space-y-4 list-disc list-inside text-slate-300" data-id="element-1894">
                <li data-id="element-1895">
                  <strong className="text-slate-100" data-id="element-1896">Work Profile:</strong>{' '}
                  Gunakan profil kerja untuk memisahkan aplikasi kantor dan
                  pribadi.
                </li>
                <li data-id="element-1897">
                  <strong className="text-slate-100" data-id="element-1898">
                    Permission Manager:
                  </strong>{' '}
                  Review izin "Location", "Microphone", dan "Camera" secara
                  berkala.
                </li>
                <li data-id="element-1899">
                  <strong className="text-slate-100" data-id="element-1900">Encrypted Backup:</strong>{' '}
                  Pastikan backup Google One terenkripsi dengan kunci layar
                  Anda.
                </li>
              </ul>
            </section>

            <section className="border-t border-slate-800 pt-8" data-id="element-1901">
              <h2 className="text-xl font-bold text-slate-100 mb-4 text-red-400" data-id="element-1902">
                Common Mistakes
              </h2>
              <ul className="space-y-3 text-slate-400" data-id="element-1903">
                <li className="flex items-start" data-id="element-1904">
                  <AlertTriangle className="h-5 w-5 text-red-500/50 mr-3 flex-shrink-0 mt-0.5" data-id="element-1905" />
                  <span data-id="element-1906">
                    Menggunakan Pattern/Pola yang mudah ditebak (bentuk L, Z,
                    dll).
                  </span>
                </li>
                <li className="flex items-start" data-id="element-1907">
                  <AlertTriangle className="h-5 w-5 text-red-500/50 mr-3 flex-shrink-0 mt-0.5" data-id="element-1908" />
                  <span data-id="element-1909">
                    Menginstall APK modifikasi (WhatsApp Mod, Game Cheat) yang
                    berisi malware.
                  </span>
                </li>
              </ul>
            </section>
          </div>

          <div className="space-y-6" data-id="element-1910">
            <Checklist id="android-checklist" title="Android Checklist" items={ANDROID_CHECKLIST} data-id="element-1911" />
            <Card className="p-6 bg-slate-900/50 border-slate-800" data-id="element-1912">
              <h3 className="font-bold text-slate-100 mb-4" data-id="element-1913">Next Steps</h3>
              <div className="space-y-3" data-id="element-1914">
                <Link to="/devices/windows" data-id="element-1915">
                  <Button variant="secondary" fullWidth className="justify-between group" data-id="element-1916">
                    Windows Protocol
                    <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" data-id="element-1917" />
                  </Button>
                </Link>
                <Link to="/ir/lost-device" data-id="element-1918">
                  <Button variant="secondary" fullWidth className="justify-between group" data-id="element-1919">
                    Lost Device Plan
                    <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" data-id="element-1920" />
                  </Button>
                </Link>
              </div>
            </Card>
          </div>
        </div>
      </div>
    </Layout>;
}